import { Dispatch, SetStateAction } from 'react'
import {faker} from '@faker-js/faker'
import { Player } from '../assets/data'
interface PlayerCardProps {
  player: Player
  setDetails: Dispatch<SetStateAction<null | Player >>
}
export const PlayerDetails = ({player}:PlayerCardProps)=>{
    const style = {
        height:'20rem',
        width:'14rem',
        'object-fit':'cover'
    }
    const wins = player.stats.wins || 0
    const losses = player.stats.losses || 0
    const pct = Math.round(wins/(wins+losses)*1000)/10
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          width: '100%',
          marginTop:'3rem'
        }}
      >
        <div style={{ width: '50%' }} title={player.name}>
          <img style={style} src={player.image} alt={player.name} />
        </div>
        <div style={{ width: '50%' }} title={player.name}>
          <ul style={{ padding: 0, margin: 0, textAlign: 'left' }}>
            <li>
              <h2>Name: {player.name}</h2>
            </li>
            <li>
              <h2>Born:</h2>
              <ul>
                <li>
                  <h3>{faker.date.birthdate().toDateString()}</h3>
                </li>
                <li>
                  <h3>{faker.location.city()}, {faker.location.country()}</h3>
                </li>
              </ul>
            </li>
            <li>
              <h2>Stats:</h2>
              <ul>
                <li>
                  <h3>Wins: {player.stats.wins}</h3>
                </li>
                <li>
                  <h3>Losses: {player.stats.losses}</h3>
                </li>
                <li>
                  <h3>Win percentage: {pct}%</h3>
                </li>
              </ul>
            </li>
            <li>
              <h2>About: {faker.person.bio()}</h2>
            </li>
          </ul>
        </div>
      </div>
    )
}
